import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const DesktopTabbedView = ({ headerTabs, handleTabClick }) => {
  const currentData = useSelector((state) => state.data.data);
  const activeHeaderTab = useSelector(
    (state) => state.activeHeaderTab.activeHeaderTab
  );
  const navigate = useNavigate();
  const handleBackButtonClick = () => {
    navigate(-1);
  };
  const getTabClass = (tabName) => {
    return `header-tab-btn  ${
      activeHeaderTab === tabName ? "bg-lb3 text-dark-blue" : "bg-[#d9d9d95c]"
    }`;
  };
  return (
    <div className="font-figtree text-white flex items-center">
      {" "}
      <ChevronLeft
        color="white"
        size="30"
        onClick={handleBackButtonClick}
        className="cursor-pointer"
      />
      {headerTabs.map(({ name, key, data }) => (
        <h4
          key={key}
          onClick={() => handleTabClick(key, data)}
          className={getTabClass(key)}
        >
          {name}
          <span className="text-sm max-lg:text-xs">
            {" "}
            ({activeHeaderTab === key ? currentData?.length : data?.length})
          </span>
        </h4>
      ))}
    </div>
  );
};

export default DesktopTabbedView;
